'use client';

import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import Wrapper from '@/components/layout/Wrapper';
import { cn } from '@/lib/utils';
import { withRef } from '@/lib/with-ref';
import { motion } from 'motion/react';
import type {
    ZStackChildElement,
    ZStackChildProps,
    ZStackElement,
    ZStackProps,
} from './types';

const ZStackRoot = withRef<ZStackElement, ZStackProps>(
  ({ id, className = '', responsive = {}, children, ...props }, ref) => {
    const classes = cn('relative w-full h-full', className);

    return (
      <ResponsiveWrapper responsive={responsive}>
        <motion.div
          id={`z-stack${id ? `-${id}` : ''}`}
          ref={ref}
          className={classes}
          {...props}
        >
          {children}
        </motion.div>
      </ResponsiveWrapper>
    );
  },
);

ZStackRoot.displayName = 'ZStack';

const ZStackChild = withRef<ZStackChildElement, ZStackChildProps>(
  (
    {
      id,
      zIndex = 0,
      asChild = false,
      className = '',
      responsive = {},
      children,
      ...props
    },
    ref,
  ) => {
    return (
      <ResponsiveWrapper responsive={responsive}>
        <Wrapper
          id={`z-stack-child${id ? `-${id}` : ''}`}
          className={cn('absolute inset-0', className)}
          style={{ zIndex }}
          asChild={asChild}
          {...props}
        >
          {children}
        </Wrapper>
      </ResponsiveWrapper>
    );
  },
);

ZStackChild.displayName = 'ZStackChild';

const ZStack = Object.assign(ZStackRoot, {
  Child: ZStackChild,
});

export default ZStack;
